import { SubjectDifficulties } from 'features/subject-difficulty';
import { AppPage } from 'common/Layout';
import { homeBreadcrumbItem } from 'shared/UI/UIKit/Breadcrumbs';

const breadcrumbs = [
  homeBreadcrumbItem,
  {
    title: 'Справочник сложности предметов',
    url: '',
  },
];

export const SubjectDifficultiesPage = () => {
  return (
    <AppPage breadcrumbs={{ items: breadcrumbs }} documentTitle="Справочник сложности предметов">
      <SubjectDifficulties />
    </AppPage>
  );
};
